/**
 * Battle Pass ("Боевой Пропуск") — shared config parsing and the level
 * formula, mirroring the backend's BattlePass\BattlePassManager exactly:
 * level = 1 + floor(gamesPlayed / gamesPerLevel), capped at the highest
 * configured level. Used by the forum frontend (profile bar, tag-page
 * button, profile badge) and kept framework-free so the admin editor could
 * reuse it too.
 */

/**
 * Parses the raw `arenaBattlePassLevels` forum attribute (or the admin-side
 * parsed setting) into a level → rewards map. Invalid entries are dropped,
 * duplicate level entries merged — same rules as BattlePassManager::levels().
 */
export function normalizeBattlePassLevels(raw) {
  const map = new Map();
  if (!Array.isArray(raw)) return map;
  for (const entry of raw) {
    var _map$get;
    const level = Number(entry == null ? void 0 : entry.level) || 0;
    if (level < 1) continue;
    const rewards = Array.isArray(entry == null ? void 0 : entry.rewards) ? entry.rewards.filter(r => r && typeof r.type === 'string') : [];
    map.set(level, [...((_map$get = map.get(level)) != null ? _map$get : []), ...rewards]);
  }
  return new Map([...map.entries()].sort((a, b) => a[0] - b[0]));
}

/** Highest configured level — the progression cap. 1 when unconfigured. */
export function battlePassMaxLevel(levels) {
  let max = 1;
  for (const level of levels.keys()) if (level > max) max = level;
  return max;
}

/** Same formula as BattlePassManager::levelForGames(). Never below 1. */
export function battlePassLevelForGames(games, gamesPerLevel, maxLevel) {
  const perLevel = Math.max(1, Math.floor(gamesPerLevel) || 1);
  return Math.min(1 + Math.floor(Math.max(0, games) / perLevel), Math.max(1, maxLevel));
}
flarum.reg.add('forumaker-arena', 'common/battlePass', { normalizeBattlePassLevels: normalizeBattlePassLevels,battlePassMaxLevel: battlePassMaxLevel,battlePassLevelForGames: battlePassLevelForGames, });